import { Injectable, HostListener, isDevMode, ApplicationRef } from '@angular/core';
import { LocaleService } from './locale.service';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { CacheService } from './cache.service';
import { first, switchMap } from 'rxjs/operators';
import { BehaviorSubject, interval } from 'rxjs';
import { GlobalFunctionService } from './global-function.service';
import { DetectDeviceService } from './detect-device.service';
import { GlobalApiService } from './global-api.service';

@Injectable({
	providedIn: 'root'
})
export class ServiceWorkerService {

	showAddToHome = false;
	defferedHomeScreenPrompt: any;
	isDev = isDevMode();
	isLogin = false;
	notificationRequested = false;
	updateAvailable = new BehaviorSubject<boolean>(false);
	setInterval;

	constructor(
		private locale: LocaleService,
		private cacheService: CacheService,
		private swUpdate: SwUpdate,
		private appRef: ApplicationRef,
		private gfService: GlobalFunctionService,
		private swPush: SwPush,
		public detectDevice: DetectDeviceService,
		private globalApiService: GlobalApiService
	) {
		this.gfService.globalBS$.subscribe((res) => {
			if (res) {
				if (res.type === 'IS_LOGIN') {
					this.isLogin = res.isLogin;
				}
			}
		});
	}

	@HostListener('window:beforeinstallprompt', ['$event'])
	onBeforeinstallprompt(e: { preventDefault: () => void; }) {
		e.preventDefault();
		this.defferedHomeScreenPrompt = e;
		// this.showAddToHome = true;
		// this.addToHomeScreen();
	}
	@HostListener('window:appinstalled', ['$event'])
	onAfterinstallprompt(evt) {
		// Log install to analytics
		console.log('Application is installed.');
	}

	addToHomeScreen() {
		console.log(this.defferedHomeScreenPrompt);
		this.showAddToHome = false;
		if (!this.defferedHomeScreenPrompt) {
			// The deferred prompt isn't available.
			return;
		}
		this.defferedHomeScreenPrompt.prompt();
		this.defferedHomeScreenPrompt.userChoice
			.then((choiceResult: { outcome: string; }) => {
				if (choiceResult.outcome === 'accepted') {
					console.log('User accepted the A2HS prompt');
				} else {
					console.log('User dismissed the A2HS prompt');
				}
				this.defferedHomeScreenPrompt = null;
			});
	}

	checkForAppUpdate() {
		// this.appRef.isStable.pipe(
		// 	first(stable => stable),
		// 	switchMap(() => interval(1 * 60 * 60 * 1000))
		// ).subscribe(() => {
		// 	console.log('Checking app stability.');
		// 	if (this.swUpdate.isEnabled) {
		// 		console.log('Checking app stability.......>', this.swUpdate);
		// 		this.swUpdate.checkForUpdate().then(() => console.log('Checking for updates'));
		// 	}
		// });
		if (this.swUpdate.isEnabled) {
			this.setInterval = setInterval(() => {
				if (this.swUpdate.isEnabled) {
					this.swUpdate.checkForUpdate().then(() => console.log('Checking for updates'));
				}
			}, 10000);
		}
	}

	updateApp() {
		if (!this.swUpdate.isEnabled) {
			console.log('Service worker not enabled');
			return;
		}
		this.swUpdate.available.subscribe((event) => {
			console.log('current version is', event.current);
			console.log('available version is', event.available);
			if (this.setInterval) {
				clearInterval(this.setInterval);
			}
			this.showAddToHome = true;
			if (!this.updateAvailable.value) {
				this.updateAvailable.next(true);
			}
			// if (confirm("New version is available. Update it now!")) {
			// 	this.activateUpdate();
			// }
		});
		this.swUpdate.activated.subscribe((event) => {
			console.log('old version was', event.previous);
			console.log('new version is', event.current);
			console.log('Updated to new version');
		});
	}

	activateUpdate() {
		this.swUpdate.activateUpdate().then(async () => {
			await this.cacheService.clearCache('ngsw', null, true);
		});
	}

	getDisplayMode() {
		const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
		if (document.referrer.startsWith('android-app://')) {
			return 'twa';
		} else if (navigator['standalone'] || isStandalone) {
			return 'standalone';
		}
		return 'browser';
	}

	requestPushNotification() {
		if (this.isLogin && !this.isDev) {
			this.notificationRequested = true;
			let i = 0;
			this.swPush.subscription.subscribe(data => {
				i = i + 1;
				if (i === 1) {
					if (data) {
						this.gfService.globalBS$.next(
							{
								type: 'NOTIFICATION_STATE',
								state: true
							}
						);
					}
					if (!data) {
						this.swPush.requestSubscription({ serverPublicKey: this.gfService.sessionUser.publicVapidKey }).then(subscription => {
							let notificationType;
							const data = this.detectDevice.fingerPrint;
							if (data && data.browserName && data.browserName.includes('Safari')) {
								notificationType = 2;
							} else {
								notificationType = 1;
							}
							const apiData: any = {
								userID: this.gfService.sessionUser.userID,
								notificationType,
								subscription
							};
							const headers: any = {};
							this.globalApiService.addSubscription(apiData, headers).subscribe(
								(response) => {
									if (response) {

									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
								}
							)
								.add(() => {
									this.gfService.globalBS$.next(
										{
											type: 'NOTIFICATION_STATE',
											state: true
										}
									);
								});
						})
							.catch(error => {
								this.gfService.globalBS$.next(
									{
										type: 'NOTIFICATION_STATE',
										state: false
									}
								);
							});
					}
				}
			});
		}
	}

	// window.matchMedia('(display-mode: standalone)').addEventListener((evt) => {
	// 	let displayMode = 'browser';
	// 	if (evt.matches) {
	// 		displayMode = 'standalone';
	// 	}
	// 	// Log display mode change to analytics
	// 	console.log('DISPLAY_MODE_CHANGED', displayMode);
	// });

}
